import React, { useEffect, useState } from "react";
import s from "./style.module.scss";
import GoBack from "shared/ui/GoBack";
import { GetServiceDataApi, IServiceData } from "shared/api/serviceData";

const About: React.FC = () => {
  const [serviceData, setServiceData] = useState<IServiceData | null>(null);

  useEffect(() => {
    GetServiceDataApi({ id: 1 }).then((res) => {
      setServiceData(res);
    });
  }, []);

  return (
    <main className={s.about}>
      <GoBack black />
      <h1>О Бонусной программе</h1>
      <div>
        <p dangerouslySetInnerHTML={{ __html: serviceData?.parking || "" }} />
      </div>
    </main>
  );
};

export default About;
